export default __webpack_public_path__ + "static/media/maturity-assessment.4520769a.svg";